import { useState, useCallback } from 'react';

// Mock hook for managing user permissions - always returns true for testing
export const usePermissions = () => {
  const [permissions, setPermissions] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Check if user has a specific permission - always return true for testing
  const hasPermission = useCallback((permissionCode) => {
    console.log(`🔐 Mock Permission check: ${permissionCode} = true`);
    return true;
  }, []);

  // Check if user has any of the specified permissions - always return true for testing
  const hasAnyPermission = useCallback((permissionCodes) => {
    console.log(`🔐 Mock Any Permission check: ${permissionCodes.join(', ')} = true`);
    return true;
  }, []);

  // Check if user can access a navigation item - always return true for testing
  const canAccessNavigationItem = useCallback((itemKey) => {
    console.log(`🔐 Mock Navigation Permission check: ${itemKey} = true`);
    return true;
  }, []);

  // Refresh permissions - no-op for testing
  const refreshPermissions = useCallback(() => {
    console.log('🔐 Mock refresh permissions');
  }, []);

  // Get permission summary - return mock data
  const getPermissionSummary = useCallback(() => {
    return { 
      total: 10, 
      granted: 10, 
      revoked: 0, 
      categories: ['customers', 'products', 'contracts'] 
    };
  }, []);

  return {
    permissions,
    isLoading,
    hasPermission,
    hasAnyPermission,
    canAccessNavigationItem,
    refreshPermissions,
    getPermissionSummary
  };
};
